import { NewRequestPopUp } from './NewRequestPopUp';
import { VacationType } from 'src/tabs/hooks/useVacationTypes';
import { appearance } from 'src/hooks/useAlertMessage';
import { EmployeeVacationDays } from '../../../tabs/models/SummaryInterfaces';

interface NewRequestSectionProps {
  isPopupVisible: boolean;
  showPopup: () => void;
  hidePopup: () => void;
  setShowMessage: (message: string, appearance: appearance) => void;
  holidays: Array<string>;
  vacationTypes: VacationType[];
  getUserRequests: (
    statusCode?: string[],
    vacationTypeId?: string[],
    vacationTypes?: VacationType[]
  ) => Promise<void>;
  vacationType: string[];
  vacationStatus: string[];
  getSummary: () => Promise<void>;
  vacationPeriodNextYear: EmployeeVacationDays;
  selectedYear: number;
  vacationPeriod: EmployeeVacationDays;
  mappedVacationTypes: {
    key: string;
    text: string;
  }[];
}

export const NewRequestSection = ({
  getSummary,
  isPopupVisible,
  hidePopup,
  setShowMessage,
  holidays,
  vacationTypes,
  getUserRequests,
  vacationStatus,
  vacationType,
  vacationPeriodNextYear,
  selectedYear,
  vacationPeriod,
  mappedVacationTypes,
}: NewRequestSectionProps) => {
  return (
    <>
      <NewRequestPopUp
        mappedVacationTypes={mappedVacationTypes}
        vacationPeriod={vacationPeriod}
        selectedYear={selectedYear}
        vacationPeriodNextYear={vacationPeriodNextYear}
        getSummary={getSummary}
        isPopupVisible={isPopupVisible}
        hidePopup={hidePopup}
        setShowMessage={setShowMessage}
        holidays={holidays}
        vacationTypes={vacationTypes}
        getUserRequests={getUserRequests}
        vacationType={vacationType}
        vacationStatus={vacationStatus}
      />
    </>
  );
};
